import React, { ChangeEvent, useState } from 'react';
import { Modal, Button, Input } from 'antd';

interface modalCouponProps{
  closeModal: any,
  modalState: any
}

export default function ModalCoupon({ closeModal, modalState }:modalCouponProps) {
  const [emptyError, setEmptyError] = useState(false);
  const [coupon, setCoupon] = useState('');

  function closeModalWindow() {
    closeModal();
  }

  function submitCoupon() {
    if (coupon === '') {
      setEmptyError(true);
    }
  }

  function handleChange(e:ChangeEvent<HTMLInputElement>) {
    setCoupon(e.target.value);
    setEmptyError(false);
  }

  return (
    <Modal
      title="Consumir cupón"
      width={296}
      visible={modalState}
      onCancel={closeModalWindow}
      footer={[
        <Button key="close" onClick={() => closeModalWindow()}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={() => submitCoupon()}>
          Consumir
        </Button>,
      ]}
      className="modalNewTest"
    >
      <Input
        placeholder="Nº de cupón"
        className="ant-input"
        type="number"
        style={{ width: '100%', height: 40 }}
        onChange={handleChange}
        onPressEnter={submitCoupon}
      />
      {emptyError
        ? (
          <div>
            <p className="errors">¡ Introduzca número de cupón! </p>
          </div>
        )
        : null}
    </Modal>
  );
}
